module.exports = __webpack_public_path__ + "assets/hoogste_korting.171691be.svg";